import login from '@/api/login';
import setting from '@/api/setting';
import watermark from '@/utils/sy-watermark.js';
let Base64 = require('js-base64').Base64;
import { removeItem } from '@/utils/cookie.js';

const state = {
  sessionId: '',
  menus: [],
  userSelf: {},
  userInfo: {},
  userSupplier: {},
};
const mutations = {
  SET_LOACLSTORAGE: (state, obj) => {
    state[Object.keys(obj)] = Object.values(obj);
    localStorage.setItem(Object.keys(obj), Object.values(obj));
  },
  CLEAR_LOACLSTORAGE: state => {
    localStorage.clear();
    state.sessionId = '';
  },
  USER_SELF: (state, obj) => {
    state.userSelf = obj;
  },
  USER_SUPPLIER: (state, obj) => {
    state.userSupplier = obj;
  },
};
const actions = {
  login ({ commit }, userInfo) {
    const { XExtTenantId, username, password } = userInfo;
    // 获取用户填写的XExtTenantId，将值存入缓存中，需要在请求API时设置到头部信息,如果该值为空，则给定默认值为管理员帐号
    let XExtTenantIdValue = XExtTenantId || 'defaultExtTenantId';
    commit('SET_LOACLSTORAGE', { XExtTenantId: XExtTenantIdValue });
    const params = {
      username: username,
      password: Base64.encode(password),
    };

    return new Promise((resolve, reject) => {
      login
        .login(params)
        .then(result => {
          // 登录成功后将sessionId存入缓存
          commit('SET_LOACLSTORAGE', {
            sessionId: result.data.sessionId,
          });
          // sessionValid判断是否关闭浏览器
          sessionStorage.setItem('sessionValid', 1);
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  logout ({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      login.logout().then(result => {
        // 清除cookie
        removeItem();
        commit('CLEAR_LOACLSTORAGE');
        commit('USER_SELF', {});
        dispatch('publicData/clearAllStore', null, { root: true });
        // 清除个人信息的水印 只保留系统信息
        watermark.load({
          watermark_txt: 'SRM-MALL',
        });
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
    });
  },
  //登录成功后获取用户信息
  userSelf ({ commit }) {
    return new Promise((resolve, reject) => {
      login
        .userSelf()
        .then(result => {
          // 登录成功后显示个人账号的水印
          watermark.load({
            watermark_txt: 'SRM-MALL' + ' ' + result.data.user.name,
            watermark_width: 500
          });
          // 获取用户信息存入store 要过滤出按钮权限和菜单权限
          const menusPermissions = result.data.menus.filter(
            item => item.type === 'router',
          );
          const buttonPermissions = result.data.menus
            .filter(item => item.type === 'button')
            .map(item => item.code);
          commit('USER_SELF', {
            ...result.data,
            menusPermissions,
            buttonPermissions,
          });
          // 该判断是为了区分该用户是否有菜单权限
          if (result.data.menus.length === 0) {
            reject({
              msg: '不好意思，您没有权限！',
            });
          } else {
            resolve(result.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  //登录成功后获取用户信息
  userSupplier ({ commit }) {
    return new Promise((resolve, reject) => {
      setting
        .getCUser(state.userSelf.user.id)
        .then(result => {
          if (result.data.customerId === '1') {
            // 外部用户
            setting
              .getByCode(result.data.supplierCode)
              .then(res => {
                commit('USER_SUPPLIER', {
                  ...res.data,
                  customerId: result.data.customerId,
                  supplierCode: result.data.supplierCode,
                  userRole: result.data.userRole,
                  mobile: result.data.mobile
                });
                resolve(res.data);
              })
              .catch(err => {
                reject(err);
              });
          } else {
            // 内部用户
            setting
              .getListAllByUserId(result.data.id)
              .then(res => {
                commit('USER_SUPPLIER', {
                  ...res.data,
                  customerId: result.data.customerId,
                  userRole: result.data.userRole,
                  brand: result.data.brand
                });
                resolve(res.data);
              })
              .catch(err => {
                reject(err);
              });
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  //登录成功后，更新用户登录时间
  updateLoginDate () {
    return new Promise((resolve, reject) => {
      login
        .updateLoginDate()
        .then(() => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 清除缓存
  clearLoaclstorage ({ commit }) {
    commit('CLEAR_LOACLSTORAGE');
  },
  // 清除store中的用户信息
  clearUserSelf ({ commit }) {
    commit('USER_SELF', {});
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
